export default "__VITE_ASSET__bOMQ5fl5__"